export function KrPerformanceEmpty() {
  return (
    <section className="state-box">
      <strong>KR 운영 성과 데이터 없음</strong>
      <p>
        현재 국내장은 replay 검증 단계입니다. 실제 KR 실현손익, 일별 equity,
        drawdown, 포지션 성과는 KST shadow/replay loop 검증 후 표시합니다.
      </p>
    </section>
  );
}

export function UsLivePerformanceEmpty() {
  return (
    <section className="state-box">
      <strong>US live_pilot 성과 데이터 없음</strong>
      <p>
        현재 live_pilot 성과는 이전 US 운영 리포트와 섞어 표시하지 않습니다.
        첫 live 체결과 live 전용 일별 성과 집계가 생기면 이 화면에 표시합니다.
      </p>
    </section>
  );
}

export function UnavailablePerformance({ error }: { error: string | null }) {
  return <div className="state-box error-state">API 오류: {error || '운영 성과 데이터 없음'}</div>;
}

export function Metric({ title, value, tone = '' }: { title: string; value: string; tone?: string }) {
  return (
    <article className={`op-metric ${tone}`}>
      <span>{title}</span>
      <strong>{value}</strong>
    </article>
  );
}
